import React from "react";

import "./index.scss";
import { HomeCardProps } from "models/HomeCard";

const HomeCard = ({
  media,
  poster,
  largeHeader = false,
  header,
  title,
  subtitle,
  bottomText = true,
  onClick,
  customClass,
}: HomeCardProps) => {
  return (
    <div
      className={`home-card ${customClass || ""} ${
        bottomText ? "bottom-text" : ""
      }`}
      onClick={onClick}
    >
      {media && (
        <video
          className="video"
          src={media}
          poster={poster}
          muted
          autoPlay
          loop
        />
      )}

      <div className="home-card-content">
        {header && (
          <h2 className={`home-card-header heading-${largeHeader ? 3 : 4}`}>
            {header}
          </h2>
        )}
        {title && <h1 className="home-card-title heading-1">{title}</h1>}
        {subtitle && <p className="body underline">{subtitle}</p>}
      </div>
    </div>
  );
};

export default HomeCard;
